import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaTimes, FaBook } from "react-icons/fa";
import { GiPencil } from "react-icons/gi";

const ComparePassageModal = ({ isOpen, onClose, stats }) => {
  if (!isOpen) return null;

  const comparison = stats?.comparison || [];

  const renderOriginal = () => {
    return comparison.map((item, index) => {
      switch (item.type) {
        case "correct":
          return (
            <span key={index} className="px-1 text-gray-800">
              {item.refWord}{" "}
            </span>
          );

        case "missing":
          return (
            <span
              key={index}
              className="px-1 bg-yellow-200 text-yellow-900 rounded"
            >
              {item.refWord}{" "}
            </span>
          );

        case "substitution":
        case "capitalization":
        case "punctuation":
          return (
            <span
              key={index}
              className="px-1 bg-red-200 text-red-800 rounded"
            >
              {item.refWord}{" "}
            </span>
          );

        case "extra":
          return null;

        default:
          return (
            <span
              key={index}
              className="px-1 bg-red-200 text-red-800 rounded"
            >
              {item.refWord}{" "}
            </span>
          );
      }
    });
  };

  const renderUser = () => {
    return comparison.map((item, index) => {
      switch (item.type) {
        case "correct":
          return (
            <span key={index} className="px-1 text-gray-800">
              {item.userWord}{" "}
            </span>
          );

        case "extra":
          return (
            <span
              key={index}
              className="px-1 bg-red-200 text-red-800 line-through rounded"
            >
              {item.userWord}{" "}
            </span>
          );

        case "missing":
          return null;

        case "substitution":
        case "capitalization":
        case "punctuation":
          return (
            <span
              key={index}
              className="px-1 bg-red-200 text-red-800 rounded"
            >
              {item.userWord}{" "}
            </span>
          );

        default:
          return (
            <span
              key={index}
              className="px-1 bg-red-200 text-red-800 rounded"
            >
              {item.userWord}{" "}
            </span>
          );
      }
    });
  };

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="bg-white w-full max-w-6xl rounded-2xl shadow-2xl overflow-hidden"
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 30, opacity: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          {/* HEADER */}
          <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-5 flex justify-between items-center">
            <h2 className="text-xl font-bold text-white">
              Compare Dictation
            </h2>

            <button
              onClick={onClose}
              className="text-white hover:text-gray-200 transition"
            >
              <FaTimes className="text-2xl" />
            </button>
          </div>

          {/* BODY */}
          <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">

            {/* ORIGINAL PASSAGE */}
            <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
              <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
                <FaBook className="text-blue-500" />
                Original Dictation
              </h3>

              <div className="h-72 overflow-y-auto bg-white p-4 rounded-lg border text-gray-800 leading-relaxed whitespace-pre-wrap">
                {renderOriginal()}
              </div>
            </div>

            {/* USER PASSAGE */}
            <div className="bg-gray-50 rounded-xl p-4 border border-gray-200">
              <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center gap-2">
                <GiPencil className="text-green-500" />
                Your Typed Text
              </h3>

              <div className="h-72 overflow-y-auto bg-white p-4 rounded-lg border text-gray-800 leading-relaxed whitespace-pre-wrap">
                {renderUser()}
              </div>
            </div>
          </div>

          {/* FOOTER INFO */}
          <div className="bg-gray-100 text-sm text-gray-600 px-6 py-3 flex gap-6">
            <div>
              <span className="inline-block w-4 h-4 bg-red-200 mr-2 rounded"></span>
              Mistake
            </div>
            <div>
              <span className="inline-block w-4 h-4 bg-yellow-200 mr-2 rounded"></span>
              Missing Word
            </div>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ComparePassageModal;
